export default function StringFilter(string) {
  if (string) {
    if (Array.isArray(string) && string.length < 1) return
    const hasGTE = string.includes('GTE')
    const hasLTE = string.includes('LTE')
    let str = string
    const mapObj = {
      GTE: '',
      LTE: ''
    }
    str = str.replace(/GTE|LTE/gi, function (matched) {
      return mapObj[matched]
    })
    str = str.replace(/\s/g, '')
    str = str.split(':')
    return {
      GTE: hasGTE && !hasLTE ? str[0] : hasGTE ? str[0] : undefined,
      LTE: hasLTE ? (hasGTE ? str[1] : str[0]) : undefined
    }
  }
}
